import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Select } from 'foundations-components/transitional/components/Select';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { STANDALONE_CORE_SEATS } from '../../constants/ReleaseInsights';
import { NavItemEnum, SegmentedNavItems } from '../../constants/routing/NavItems';
import { useHasReleaseInsight } from '../../hooks/useBulkPurchaseOptions';
import { isUngatedForBreezeIntelligenceSelector, isUngatedForHubSpotCreditsSelector, isUngatedForMarketingPlusSelector } from '../../selectors/GatingSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MobileDropdownNav = ({
  selectedNavItem
}) => {
  const history = useHistory();
  const [currNavItem, selectCurrNavItem] = useState(selectedNavItem);
  const isUngatedToMarketingPlus = useSelector(isUngatedForMarketingPlusSelector);
  const isUngatedForBreezeIntelligence = useSelector(isUngatedForBreezeIntelligenceSelector);
  const isUngatedForHubSpotCredits = useSelector(isUngatedForHubSpotCreditsSelector);
  const {
    hasReleaseInsight: isSmartCrm,
    loading: isLoadingSmartCrm
  } = useHasReleaseInsight({
    releaseInsight: STANDALONE_CORE_SEATS
  });
  const navItems = SegmentedNavItems;
  const shouldHideNavItem = item => {
    return item === NavItemEnum.MARKETING_PLUS && !isUngatedToMarketingPlus || item === NavItemEnum.ADD_ONS ||
    // not available on mobile or public
    item === NavItemEnum.BREEZE_INTELLIGENCE && !isUngatedForBreezeIntelligence || item === NavItemEnum.HUBSPOT_CREDITS && !isUngatedForHubSpotCredits || item === NavItemEnum.RECOMMENDED ||
    // not available on mobile or public
    item === NavItemEnum.SMART_CRM && (!isSmartCrm || isLoadingSmartCrm) // don't show smart crm link if not ungated
    ;
  };
  const navItemOptions = Object.values(navItems).flat().filter(navItem => !shouldHideNavItem(navItem)).map(navItem => {
    const key = `pricingPage.pages.products.tabs.${navItem}.tabTitle`;
    return {
      text: I18n.text(key),
      value: navItem
    };
  });
  const handleChange = evt => {
    evt.preventDefault();
    const newNavItem = evt.currentTarget.value;
    selectCurrNavItem(newNavItem);
    history.push(`/${newNavItem}`);
  };
  return /*#__PURE__*/_jsxs(View, {
    marginBlock: "0",
    paddingInline: "300",
    children: [/*#__PURE__*/_jsx(Text, {
      as: "div",
      typography: "body-125",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricingPage.tabs.pricingAndPlans"
      })
    }), /*#__PURE__*/_jsx(Select, {
      searchable: false,
      options: navItemOptions,
      anchorType: "button",
      onChange: handleChange,
      value: currNavItem,
      valueRenderer: props => {
        return /*#__PURE__*/_jsx(Flex, {
          justifyContent: "start",
          children: props.text
        });
      }
    })]
  });
};
export default MobileDropdownNav;